import React, { PureComponent } from 'react';

class SelectOptionLabel extends PureComponent {
  render() {
    const { children } = this.props;
    return children;
  }
}

export default SelectOptionLabel;
